module.exports = __webpack_public_path__ + "img/13.b409c6f5.jpg";